import { useState } from "react";
import { NextSeo } from "next-seo";
import dynamic from "next/dynamic";
import Layout from "@/components/layout";
import {
  getAllStickyPosts,
  getAllPostsForHome,
  getAllCategoriesWithSlug,
} from "@/lib/api";

const Top = dynamic(() => import("@/components/contact-us/top"), {
  suspense: true,
});

const Form = dynamic(() => import("@/components/quotation/form"), {
  suspense: true,
});

const MoreStories = dynamic(() => import("@/components/blog/more-posts"), {
  suspense: true,
});

export default function Quotation({ sticky }) {
  const [heroPost] = useState(sticky.edges);

  return (
    <Layout>
      <NextSeo
        title="ISO Compliance Made Easy: Get Your Quotation Today"
        canonical="https://isauditr.com/quotation"
        description="Looking for an easy way to achieve ISO compliance? Get your quotation today and take the first step towards certification."
        twitter={{
          cardType: "summary_large_image",
          site: "@isauditr",
          handle: "@isauditr",
          creator: "@isauditr",
          title: "ISO Compliance Made Easy: Get Your Quotation Today",
          description:
            "Looking for an easy way to achieve ISO compliance? Get your quotation today and take the first step towards certification.",
        }}
        openGraph={{
          type: `website`,
          locale: `en_US`,
          siteName: "IS Auditr",
          title: "ISO Compliance Made Easy: Get Your Quotation Today",
          description:
            "Looking for an easy way to achieve ISO compliance? Get your quotation today and take the first step towards certification.",
          url: `https://isauditr.com/quotation`,
          publisherName: "IS Auditr",
          publisherLogo: "https://isauditr.com/images/logo.svg",
        }}
      />

      <div
        data-elementor-type="wp-page"
        data-elementor-id="30"
        className="elementor elementor-30"
      >
        <Top
          title="Cost of becoming compliant?"
          subTitle="Please complete the questionnaire and send it back to the respective sales person in-charge."
        />
        <Form />

        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-be11077 elementor-section-full_width elementor-reverse-mobile elementor-section-height-default elementor-section-height-default"
          data-id="be11077"
          data-element_type="section"
        >
          <div
            className="elementor-container elementor-column-gap-no"
            style={{
              padding: "4%",
              margin: "5%",
              borderStyle: "solid",
              borderWidth: "2px 0 0",
              borderColor: "#E23125",
              transition:
                "background .3s,border .3s,border-radius .3s,box-shadow .3s",
            }}
          >
            <div className="container px-8 mx-auto xl:px-5 max-w-screen-lg">
              {heroPost.length > 0 && (
                <MoreStories title="Check out some posts" posts={heroPost} />
              )}
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
}

export const getStaticProps = async ({ preview = false }) => {
  const allPosts = await getAllPostsForHome(preview, null);
  const sticky = await getAllStickyPosts(preview, null);
  const allCats = await getAllCategoriesWithSlug();

  return {
    props: { allPosts, sticky, allCats, preview },
    revalidate: 10,
  };
};
